const CommentRouter = [
    {
      path: '/comment-management',
      name: 'CommentManagement',
      layout: "dashboard",
      component: () => import('@/views/LandingPage/Comment/index.vue'),
      meta: {
        title: 'Quản lý comment',
        openSidebarKey: 'comment-management',
      }
    }
  ]
  
  export default CommentRouter